export default __webpack_public_path__ + "static/media/intro.388b3e83.md";